var exports = {
  "k": "x31de4314--beba20--container",
};

module.exports = exports;
